import { Ng2StateDeclaration, loadNgModule } from '@uirouter/angular';
import { Transition, StateDeclaration } from '@uirouter/core';
import { EarlyAccessService } from '@monsido/services/early-access/early-access.service';

const lazyLoadAccessibilityModule = async (transition: Transition, stateObject: StateDeclaration) => {
    let useRedesignedModule = false;

    try {
        // Ensure parent customer resolve finished and SessionService.me is initialized.
        await transition.injector().getAsync('validateCustomer');
    } catch {
        // Fail-closed on unresolved parent state dependencies.
    }

    try {
        const earlyAccessService: EarlyAccessService = transition.injector().get(EarlyAccessService);
        useRedesignedModule = earlyAccessService.isFeatureEnabled('redesignAccessibility');
    } catch {
        // Fail-closed: if EAP evaluation fails (e.g., user state not yet resolved),
        // fall back to legacy module. User will get access once session resolves.
    }

    if (useRedesignedModule) {
        return loadNgModule(
            () => import('@client/app/feature-modules/accessibility/accessibility.module')
                .then(m => m.AccessibilityModule),
        )(transition, stateObject);
    } else {
        return loadNgModule(
            () => import('@client/app/pages/accessibility/accessibility.module')
                .then(m => m.LegacyAccessibilityModule),
        )(transition, stateObject);
    }
};

export const createAccessibilityFutureState = (): Ng2StateDeclaration => {
    return {
        name: 'base.customer.domain.accessibility.**',
        url: '/accessibility',
        lazyLoad: lazyLoadAccessibilityModule,
    };
};
